import {List as MantineList} from '@mantine/core';

/**
 * Ordered/unordered list (with `List.Item`) — design-layer pass-through over Mantine `List`.
 * @registry Pass-through Mantine List; import this instead of @mantine/core outside src/design.
 */
export const List = MantineList;
